import { Badge } from "@/components/ui/badge";
import { Clock, Check, X, ArrowRight } from "lucide-react";

interface WorkflowStatusBadgeProps {
  status?: string;
  managerApprovalStatus?: string;
  hrApprovalStatus?: string;
  className?: string;
}

const WorkflowStatusBadge = ({ 
  status: directStatus,
  managerApprovalStatus, 
  hrApprovalStatus,
  className = ""
}: WorkflowStatusBadgeProps) => {
  // Compute the workflow status if not provided directly
  const getWorkflowStatus = () => {
    if (directStatus) return directStatus;
    
    if (managerApprovalStatus === 'rejected' || hrApprovalStatus === 'rejected') {
      return 'rejected';
    }
    if (hrApprovalStatus === 'approved') {
      return 'approved';
    }
    if (managerApprovalStatus === 'approved' && hrApprovalStatus === 'pending') {
      return 'pending_hr';
    }
    if (managerApprovalStatus === 'pending') {
      return 'pending_manager';
    }
    return 'pending_manager';
  };

  const status = getWorkflowStatus();

  const statusConfig: Record<string, { label: string; variant: 'secondary' | 'default' | 'destructive'; className: string; icon: typeof Clock }> = {
    pending_manager: {
      label: 'En attente Manager',
      variant: 'secondary',
      className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      icon: Clock
    },
    pending_hr: {
      label: 'En attente RH',
      variant: 'secondary',
      className: 'bg-blue-100 text-blue-800 border-blue-200',
      icon: ArrowRight
    },
    approved: {
      label: 'Approuvée',
      variant: 'default',
      className: 'bg-green-100 text-green-800 border-green-200',
      icon: Check
    },
    rejected: {
      label: 'Refusée',
      variant: 'destructive',
      className: '',
      icon: X
    }
  };

  const config = statusConfig[status] || statusConfig.pending_manager;
  const Icon = config.icon;

  return (
    <Badge 
      variant={config.variant}
      className={`${config.className} ${className}`}
    >
      <Icon className="h-3 w-3 mr-1" />
      {config.label}
    </Badge>
  );
};

export default WorkflowStatusBadge;
